import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import Divider from '@material-ui/core/Divider'
import * as utils from '@utils'

class ComponentDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'ComponentDialog')
        }
    }

    state = {
        dialogOpen: false,
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    OpenDialog(title, component) {
        this.setState({ dialogOpen: true, title: title, component: component })
    }

    closeDialog() {
        this.setState({ dialogOpen: false, title: '', component: null })
    }

    render() {
        return (
            <React.Fragment>
                <Dialog fullWidth maxWidth="xl" open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                    <DialogTitle>{this.state.title}</DialogTitle>
                    <DialogContent>{this.state.dialogOpen && this.state.component}</DialogContent>
                    <Divider />
                    <DialogActions>
                        <Button variant="contained" onClick={() => this.closeDialog()} color="primary">
                            {this.t('close')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        )
    }
}

const styles = (_theme) => {
    return {
        editorToolbar: {
            border: 'solid 1px',
            margin: '12px 0',
            borderColor: 'rgba(0, 0, 0, 0.3)',
        },
        editorWrapper: {},
        editorEditor: {
            minHeight: '300px',
            padding: '0 14px',
        },
    }
}

ComponentDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    component: PropTypes.func,
}

export default hoc(styles)(ComponentDialog)
